<template>
  <a-config-provider :locale="locale">
    <router-view/>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment from 'moment'
import {mapActions} from "vuex";
moment.locale('zh-cn');

export default {
  data() {
    return {
      locale: zhCN
    }
  },
  created() {
    this.getAllCompany();
    this.$store.dispatch('knowledgeList/getRandomId')
  },
  computed: {
    randomLength() {
      return this.$store.state.knowledgeList.randomIds;　　//需要监听的数据
    }
  },
  methods: {
    ...mapActions(['getAllCompany']),
  },
  watch: {
    randomLength(newVal) {
      if (newVal.length < 2) {
        this.$store.dispatch('knowledgeList/getRandomId')
      }
    }
  }
}
</script>

